export const defaultCatcher = (e) => {
    console.error('-------------- default catcher', JSON.stringify(e));
    console.log(e);
}